import { ToastContainer } from "react-toastify";
import MyRoutes from "./Routes/routes";
import store from "./store";
import { authCheck } from "./store/actions/auth";
import { useZendeskChat } from "hooks/useZendeskChat";

import "react-toastify/dist/ReactToastify.css";
import 'react-tooltip/dist/react-tooltip.css';
import 'Assets/css/timepicker.css';
import "./App.css";

global.Buffer = global.Buffer || require("buffer").Buffer;
store.dispatch(authCheck());

function App() {
  const zendeskRef = useZendeskChat();

  return (
    <>
      <ToastContainer />
      <MyRoutes />
      <div id="nta-zendesk-widget" ref={zendeskRef}></div>
    </>
  );
}

export default App;
